

<ng-container *ngIf="model?.Amazon">
<div class="card">
  <div class="card-body up">
    <div class="cont_info">
      <img src="../../../assets/images/amazon-giftcard.svg" class="logo-card mb-3" alt="Tarjeta Regalo Amazon">
      <h5 class="title-card mb-3">{{model.Title}}</h5>
      <div class="info-text range-date">
        {{model.StartDate | date:'dd-MM-yyyy'}} / <strong>Hasta</strong>
        {{model.EndDate | date:'dd-MM-yyyy'}}</div>
      <div class="info-text user mt-2">Total participantes: {{model.TotalUsers}}</div>
    </div>
    <div class="logo">
      <img src="../../../assets/images/amazon-simplylogo.svg" class="amazon-simply" alt="Amazon">
    </div>
  </div>
  <div class="card-body">
    <div class="cont_amount">
      <div class="info-text">Saldo Actual</div>
      <div class="total-amount">{{totalRemuneration | currency:'EUR'}}</div>
    </div>
  </div>
  <div class="card-footer">
    <img src="../../../assets/images/rg-logo-white.svg" class="logo-rg" alt="Renault Group">
    <div class="info-text" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</div>
    <div class="info-text" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</div>
  </div>
</div>
</ng-container>

<ng-container *ngIf="!model?.Amazon">
<div class="card amount-card">
  <div class="card-body">
    <h5 class="card-title">{{model.Title}}</h5>
    <div class="mb-3">
      <div class="range-date mb-3">Desde {{model.StartDate | date:'dd-MM-yyyy'}} / hasta {{model.EndDate |
        date:'dd-MM-yyyy'}}</div>
      <div class="card-text user">Total participantes: {{model.TotalUsers}}</div>
    </div>
  </div>
  <div class="card-footer bg-transparent">
    <div class="cont-footer">
      <div class="cont-amount">
        <div class="text">Remuneración:</div>
        <div class="logo-amount">
          <div class="logo-card"><img src="../../../assets/images/rg-logo-white.svg" alt="Renault Group"></div>
          <div class="amount">{{totalRemuneration | currency:'EUR'}}</div>
        </div>
      </div>
    </div>
    <div class="cont-footer">
      <p class="card-text" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</p>
      <p class="card-text" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</p>
    </div>
  </div>
</div>
</ng-container>